/** Bake the directory's 5:4 framing into the uploaded file itself. */
export async function prepareHeadshot(file: File): Promise<File> {
  if (!['image/jpeg', 'image/png', 'image/webp'].includes(file.type)) {
    throw new Error('Please choose a JPEG, PNG, or WebP photo.');
  }
  if (!file.size || file.size > 25 * 1024 * 1024) {
    throw new Error('Please choose a photo smaller than 25 MB.');
  }
  const bitmap = await createImageBitmap(file);
  try {
    const cropWidth = Math.min(bitmap.width, bitmap.height * 5 / 4);
    const cropHeight = cropWidth * 4 / 5;
    const width = Math.min(800, Math.floor(cropWidth / 5) * 5);
    if (width < 5) throw new Error('Please choose a larger photo.');
    const canvas = document.createElement('canvas');
    canvas.width = width;
    canvas.height = width * 4 / 5;
    const context = canvas.getContext('2d');
    if (!context) throw new Error('The photo could not be prepared.');
    context.drawImage(bitmap, (bitmap.width - cropWidth) / 2, 0, cropWidth, cropHeight, 0, 0, canvas.width, canvas.height);
    const blob = await new Promise<Blob>((resolve, reject) => {
      canvas.toBlob(result => result ? resolve(result) : reject(new Error('The photo could not be prepared.')), 'image/webp', 0.85);
    });
    const extension = blob.type === 'image/webp' ? 'webp' : 'png';
    return new File([blob], `headshot.${extension}`, { type: blob.type });
  } finally {
    bitmap.close();
  }
}
